export default __webpack_public_path__ + "static/media/36I-102810_-16844_0.c20df4bb.jpg";